import { render, staticRenderFns } from "./LandingGift.vue?vue&type=template&id=9d29a9f2&scoped=true"
import script from "./LandingGift.vue?vue&type=script&lang=js"
export * from "./LandingGift.vue?vue&type=script&lang=js"
import style0 from "./LandingGift.vue?vue&type=style&index=0&id=9d29a9f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d29a9f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d29a9f2')) {
      api.createRecord('9d29a9f2', component.options)
    } else {
      api.reload('9d29a9f2', component.options)
    }
    module.hot.accept("./LandingGift.vue?vue&type=template&id=9d29a9f2&scoped=true", function () {
      api.rerender('9d29a9f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingGift.vue"
export default component.exports